// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-logo-container{display:flex;align-items:center;text-decoration:none}.nav-logo-container-root{width:160px}.nav-logo-img{margin-right:2px;width:220px;transition:width .3s ease,height .3s ease}.nav-logo-img.size-sm{height:32px}.nav-logo-img.size-lg{height:50px}.nav-logo-img._gls,.nav-logo-img._gls2{width:150px}.nav-logo-img-mini{width:70px}.nav-logo-img-made-in-canada{height:38px!important}.nav-logo-text{font-size:22px;font-weight:700}", ""]);
// Exports
module.exports = exports;
